import { render, staticRenderFns } from "./cause.vue?vue&type=template&id=1c21238c&scoped=true&"
import script from "./cause.vue?vue&type=script&lang=js&"
export * from "./cause.vue?vue&type=script&lang=js&"
import style0 from "./cause.vue?vue&type=style&index=0&id=1c21238c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c21238c",
  null
  
)

export default component.exports